/**
 * @fileoverview POST handler for the "/companies/:company_id/sender_verification/tracking_domains/verify" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSenderVerificationTrackingDomainsVerifyCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdSenderVerificationTrackingDomainsVerifyProps,
  CompaniesCompanyIdSenderVerificationTrackingDomainsVerifyResult,
} from "./types";

export const putCompaniesCompanyIdSenderVerificationTrackingDomainsVerify = reactQueryMutationAdapter(
  companiesCompanyIdSenderVerificationTrackingDomainsVerifyCacheKeys,
  (
    props: PutCompaniesCompanyIdSenderVerificationTrackingDomainsVerifyProps
  ): Promise<CompaniesCompanyIdSenderVerificationTrackingDomainsVerifyResult> => {
    return fetch(
      `/companies/${props.companyId}/sender_verification/tracking_domains/verify`,
      "PUT",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
